////////////////////////////////////////////////////////////////////////////////////
// MODULE IMPORTS:
////////////////////////////////////////////////////////////////////////////////////

//import Parallax from 'parallax-js';
var popup = require("jquery-popup-overlay");

//import hyperform from 'hyperform'; // used in form.all.js\
//window.hyperform = hyperform;

////////////////////////////////////////////////////////////////////////////////////
// GLOBAL VARS:
////////////////////////////////////////////////////////////////////////////////////
window.ww; // window width (viewport width)
window.wh; // window height (viewport height)
window.dh; // window document height (full page length)
window.hh;
window.st = 0; // scroll top
window.lastScrollTop = 0; // used for tracking scroll position and direction
window.scrollDirection = "down"; // default
window.selectedClassName = 'selected'; // the selected class name for menu items
window.menuOpenClassName = 'open'; // the class that defines the open state of the menu
window.fadeInSpeed = 50; // the fade in transition speed
window.fadeOutSpeed = 75; // the fade out transition speed
window.navMouseOutDelay = 600; // the delay before the nav disappears on mouseout
window.mouseOutTimer; // the MouseOut timeout timer 
window.is_responsive = false;
window.$header = $("#wrapper > header");
window.isHome = $("body").hasClass("pageHome");
window.$bodyAndHeader = $("body").add($header);
window.scrollProgress;
window.$scrollNav = $('.scrollToTop');
window.GlobalSlickConfig = {
  rows: 0,
  accessibility: true,
  prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><span class= "fas fa-arrow-left" role="presentation"></span><span class="sr-only">Previous</span></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><span class= "fas fa-arrow-right" role="presentation"></span><span class="sr-only">Next</span></button>'
};

// Check if sitefinity page editor is open
function isSitefinityEditor() {
  return $("body").hasClass("sfPageEditor");
}

//check if in SF page editor
if (isSitefinityEditor()) {
  $("body").addClass("loaded");
}

////////////////////////////////////////////////////////////////////////////////////
// MAIN DOCUMENT READY
////////////////////////////////////////////////////////////////////////////////////

window.addEventListener('DOMContentLoaded', function () {
  refreshDimensions();
  $(window).trigger('resize');
});

////////////////////////////////////////////////////////////////////////////////////
// SCROLL EVENTS
////////////////////////////////////////////////////////////////////////////////////

// updates scroll-related variables on scroll event
function refreshScrollData() {
  updateScrollProgress();

  // Gets the scrollTop and direction and updates the global variables accordingly
  window.st = window.pageYOffset || document.documentElement.scrollTop;
  window.scrollDirection = st > lastScrollTop ? "down" : "up";
  window.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

// updates a variable with a number between 0-1 representing the percentage of the page scrolled by the user
function updateScrollProgress() {
  window.scrollProgress = document.documentElement.scrollTop / (window.dh - window.wh) * 100;
}

// make DOM changes as based on scroll data
function doScrollActions() {
  // scroll-to-top link fade in/out
  if (window.lastScrollTop > 450) {
    window.$scrollNav.fadeIn();
  } else {
    window.$scrollNav.fadeOut();
  }

  // Update header/body scrolling classes
  $bodyAndHeader.removeClass("down up").addClass(scrollDirection);

  // "top" class
  if (lastScrollTop === 0) {
    if (!$("body").hasClass("top")) {
      $bodyAndHeader.addClass("top");
      if (!window.isHome) {
        goToScribble(1);
      }
    }
  } else {
    $bodyAndHeader.removeClass("top");
  }

  // "bottom" class
  if (window.scrollProgress === 100) {
    if (!$header.hasClass("bottom")) {
      goToScribble();
    }
    $bodyAndHeader.addClass("bottom");
  } else {
    $bodyAndHeader.removeClass("bottom");
  }
}
$(window).on("scroll", function () {
  refreshScrollData(); // update global variables as needed
  doScrollActions(); // make dom modifications
});

////////////////////////////////////////////////////////////////////////////////////
// WINDOW RESIZING
////////////////////////////////////////////////////////////////////////////////////

$(window).on('resize', function () {
  refreshDimensions();
});
function refreshDimensions() {
  // update calculated dimensions (to be used on resize events, or anytime a manual refresh is required)
  window.ww = document.documentElement.clientWidth;
  window.wh = document.documentElement.clientHeight;
  window.dh = document.documentElement.scrollHeight;
  window.hh = $("header").outerHeight();
  $("main").eq(0).css({
    paddingTop: window.hh
  });
  $(".filtersContainer").css({
    top: window.hh
  });

  // ### Check if we are in Mobile (ie Responsive mode)
  if ($('.mobileHeader').css('display') === 'block') {
    is_responsive = true;
  } else {
    is_responsive = false;
  }
  refreshScrollData(); // refresh scroll data just in case...
}

////////////////////////////////////////////////////////////////////////////////////
// STICKY SIDEBAR FILTERS
////////////////////////////////////////////////////////////////////////////////////

// Sticky Sidebar (Advanced Filters)
import StickySidebar from 'sticky-sidebar';
window.addEventListener('DOMContentLoaded', function () {
  if ($(".filtersContainer").length) {
    window.sidebar = new StickySidebar('.filtersContainer', {
      containerSelector: '.leftSide',
      innerWrapperSelector: '.stickyInner',
      topSpacing: 40,
      bottomSpacing: 40
    });
  }
});
$(document).ready(window.updateStickySidebarDimensions);
window.addEventListener('load', window.updateStickySidebarDimensions);
window.updateStickySidebarDimensions = function () {
  if ($(".filtersContainer").length) {
    try {
      window.sidebar.updateSticky();
    } catch (e) {
      console.warn(e);
    }
  }
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////
// MAIN MENU
////////////////////////////////////////////////////////////////////////////////////////////////////////////

// ### Menu Functions
var pageUrlPath = window.location.pathname;

// Set default `pagecontainer` for all popups (optional, but recommended for screen readers and iOS*)
$.fn.popup.defaults.pagecontainer = '#wrapper';
var $focusables = $(":focusable");

// Initialize the plugin
if (!isSitefinityEditor()) {
  var $hamburger = $(".hamburger");
  var $mobileHeader = $('#mobileHeader').popup({
    onopen: function onopen() {
      $hamburger.addClass("open");
      $(".searchHiddenWrapper").slideUp(100);
    },
    onclose: function onclose() {
      $hamburger.removeClass("open");
      if ($mobileHeader.data("openingSearch") === true) {
        $(".searchHiddenWrapper").slideUp(100);
        $mobileHeader.data("openingSearch", false);
      }

      //$focusables.eq($focusables.index($(".hamburger")) + 1).focus();
    },
    closetransitionend: function closetransitionend() {
      //$("header a").first().hover().focus();
      //$("header").first().click();
      $(".hamburger").blur();
    }
  });
  $(".hamburger").on("click", function () {
    // use the button as a toggle instead of an openelement
    $mobileHeader.popup("toggle");
  });
}

/* Submenu items */

$(".menuGrid span.toggle").on("click", function () {
  toggleSubMenu($(this).parent());
  return false;
}).on("keypress", function (e) {
  if (e.which === 13) {
    // enter key code
    toggleSubMenu($(this).parent());
    return false;
  }
});

// Toggle the submenu
function toggleSubMenu($subMenu) {
  if ($subMenu.hasClass(menuOpenClassName)) {
    collapseSubMenu($subMenu);
  } else {
    expandSubMenu($subMenu);
  }
}
function expandSubMenu($subMenu) {
  $subMenu.addClass(menuOpenClassName);
  $subMenu.children('ul.subMenu').slideDown();
}
function collapseSubMenu($subMenu) {
  $subMenu.removeClass(menuOpenClassName);
  $subMenu.children('ul.subMenu').slideUp();
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////
///SEARCH BOX EXPAND FUNCTIONALITY
//////////////////////////////////////////////////////////////////////////////////////////////////////////

$(".searchExpand").on("click", function () {
  if ($(this).hasClass("open")) {
    $(this).removeClass("open");
    $("body").removeClass("searchVisible");
    $(".searchHiddenWrapper").slideUp(200, function () {
      $(window).trigger('resize');
    });
    $mobileHeader.data("openingSearch", false);
  } else {
    $(this).addClass("open");
    $("body").addClass("searchVisible");

    // hide the menu if it's open
    $mobileHeader.popup("hide");
    $mobileHeader.data("openingSearch", true);
    $(".searchHiddenWrapper").slideDown(200, function () {
      $(window).trigger('resize');
      $(this).find("input[type=search]").focus();
    });
  }
});
$(".searchCollapse").on("click", function () {
  $(".searchHiddenWrapper").slideUp();
});

/////////////////////////////////////////////////////////////////////////////////////////////////////////
// SVG SCRIBBLE ANIMATION
//////////////////////////////////////////////////////////////////////////////////////////////////////////

window.lastScribbleAnimated = 1;
window.scribbleCount = $(".animatedScribble").eq(0).find("svg").length;
window.$distinctScribbles = $(".animatedScribble").eq(0).find("svg");
window.scribblesEnabled = true;
if ($("html[class*='k-edge1'][class*='k-ie1']").length) {
  $(".hidden .animatedScribble").remove();
  window.scribblesEnabled = false;
}
var $scribbleSections = $(".scribbleSection");
if (!isSitefinityEditor() && window.scribblesEnabled && $scribbleSections.length) {
  // clone the overlay element as needed throughout the page
  $(".hidden .animatedScribble").clone().addClass("scribbleOverlay").prependTo($scribbleSections);
  $(".hidden .animatedScribble").clone().addClass("scribbleOverlay").insertBefore($("#wrapper"));
  window.$distinctScribbles = $(".animatedScribble").eq(0).find("svg");

  // remove the original (hidden) svgs
  $(".hidden .animatedScribble").remove();

  // remove duplicate masks/ids
  $(".animatedScribble").eq(0).find("mask").each(function () {
    var id = $(this).attr("id");
    if (id) {
      $("mask[id='" + id + "']").not($(this)).remove();
    }
  });
  var $scribbles = $('.animatedScribble');

  // set animation delays for stroke segments.
  $scribbles.each(function () {
    var $scribble = $(this);
    var $svgs = $scribble.find("svg").first();
    $svgs.each(function () {
      var $svg = $(this);
      var $segments = $svg.find("mask path");
      var lastSegmentDelay = 0; // ms

      $.each($segments, function (i, el) {
        var $segment = $(this);
        var delay = $segment.parent("mask").attr("data-stroke-delay");
        delay = delay ? delay : lastSegmentDelay + 100;
        $segment.css({
          cssText: "transition-delay: " + delay + "ms!important;"
        });
      });
    });
  });
  var $scrollSections = $(".scrollSection");
  $.each($scrollSections, function (i, el) {
    var waypointShow = new Waypoint({
      element: el,
      handler: function handler(direction) {
        if (direction === "down") {
          if ($(el).find(".homeSlideshow").length) {
            goToScribble(1);
          } else {
            goToScribble(); // trigger a RANDOM scribble change
          }
        }
      },
      offset: function offset() {
        return $(window).outerHeight() * 0.6; // trigger at 609% from top
      }
    });
  });
  if (!$("svg.animate").length) {
    window.lastScribbleAnimated = 1;
    $(".animatedScribble svg:nth-child(1)").addClass("animate");
  }
  updateFirstScribbleColour();
  $(window).on("scroll", function () {
    updateFirstScribbleColour();
  });
} else {
  // remove from the page on the back-end if they appear anywhere
  $(".animatedScribble").remove();
}
function updateFirstScribbleColour() {
  $(".animatedScribble ").css({
    cssText: "filter:grayscale(" + window.lastScrollTop / window.wh + ")!important;opacity:" + Math.max(1 - window.lastScrollTop / window.wh, 0.2) + ";"
  });
}
window.lastRandomScribbleIndex = 1;
function goToScribble(scribbleIndex) {
  window.$distinctScribbles = $(".animatedScribble").eq(0).find("svg");
  if (!scribbleIndex) {
    // get a random scribble

    var $availableScribbles = window.$distinctScribbles.not(window.$distinctScribbles.first()); // ignore active scribble AND top scribble.
    $availableScribbles = $availableScribbles.not(".animate"); // ignore active scribble AND top scribble.

    var rando = Math.floor(Math.random() * $availableScribbles.length);
    window.lastRandomScribbleIndex = rando;
    scribbleIndex = window.$distinctScribbles.index($availableScribbles.eq(rando)) + 1;
    //console.log("random scribble index: ", scribbleIndex);
  }
  var $scribbleToAnimate = $(".animatedScribble svg:nth-child(" + scribbleIndex + ")");
  $(".animatedScribble svg.animate").removeClass("animate");
  $scribbleToAnimate.addClass("animate");
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// SCROLL TO LOCATION ON PAGE
//////////////////////////////////////////////////////////////////////////////////////////////////////////

// Select all links with hashes
$('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]').not('[href="#0"]').click(function (event) {
  // On-page links
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top - 40
      }, 1000, function () {
        // Callback after animation
        // Must change focus!
        var $target = $(target);
        $target.focus();
        if ($target.is(":focus")) {
          // Checking if the target was focused
          return false;
        } else {
          $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
          $target.focus(); // Set focus again
        }
        ;
      });
    }
  }
});
window.addEventListener('DOMContentLoaded', function () {
  function scrollToLocation(scrollTo, animate, speed) {
    speed = typeof speed !== 'undefined' ? speed : 500;
    animate = typeof animate !== 'undefined' ? animate : true;
    scrollTo = $(scrollTo);
    var container = $('html, body');
    if (animate) {
      container.animate({
        scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()
      }, speed);
    } else {
      // Required so that element on page is loaded
      setTimeout(function () {
        container.scrollTop(scrollTo.offset().top - container.offset().top + container.scrollTop());
      }, 250);
    }
  }
});

// ###### Scroll to Tab Content
// ### Click event for the "Scroll to Tab" for TabStrip (works for all RadTabs)
$(document).on("click", ".tablist a", function () {
  if (window.ww < 767) {
    scrollToAnchorTab();
  }
});
// ### "Scroll to Tab Content function
function scrollToAnchorTab() {
  var aTag = $(".tabContents"); // need to add this class "tabContainer" on any manually added RadMultiPage
  $('html,body').animate({
    scrollTop: aTag.offset().top
  }, 'slow');
}

// ###### Scroll to Top
// ### Check to see if the window is top if not then display "Scroll to Top" button
// ### Click event for the "Scroll to Top" button
$(document).on('click', '.scrollToTop', function () {
  $('html, body').animate({
    scrollTop: 0
  }, 800);
  return false;
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Counters (using jquery.counter-up.js and waypoints)
//////////////////////////////////////////////////////////////////////////////////////////////////////////

window.addEventListener('DOMContentLoaded', function () {
  var $counters = $('.counter');
  if ($counters.length) {
    $counters.each(function (i, counter) {
      // No need to call waypoints manually ... the counter-up plugin has the call built-in
      $(counter).counterUp({
        delay: 20,
        time: 2000
      });
    });
  }
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// SMOOTH PAGE TRANSITIONS / LOADING SPINNERS
//////////////////////////////////////////////////////////////////////////////////////////////////////////

window.destinationUrl = ""; // explicit global declaration

//window.addEventListener('DOMContentLoaded', function () {
//    $("body").addClass("loaded");
//});

window.addEventListener('DOMContentLoaded', function () {
  // Add a "loaded" class when the document is finshed loading
  $("body").addClass("loaded");
  $("body").removeClass("loading");

  // Revert to initial state
  window.onbeforeunload = function () {
    if (!isExternal(destinationUrl)) {
      $("body").addClass("unloading");
      $("body").removeClass("loaded");
    }
  };
});
$(window).bind("pageshow", function (event) {
  // safari fix for back button causing a blank screen
  if (event.originalEvent.persisted) {
    $("body").addClass("loaded");
  }
});

// store the destination url to be used for page loading animation logic
$(document).on("click", "a[href]", function (event) {
  destinationUrl = $(this).attr("href");
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// LAZY   http://jquery.eisbehr.de/lazy/
//////////////////////////////////////////////////////////////////////////////////////////////////////////

$('.lazy').lazy({
  threshold: 0 // images will load when 100 px from viewport edge
});

// Needed for lazy loading in some sliders to load images on click/swipe of next slide
function scrollUpDown1px() {
  setTimeout(function () {
    $(window).scrollTop($(window).scrollTop() - 1);
    $(window).scrollTop($(window).scrollTop() + 1);
  }, 250);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// FORMS / AUTO-FILL
//////////////////////////////////////////////////////////////////////////////////////////////////////////

// SEARCH BOX - PLACEHOLDER TEXT
$('.search input[type="text"]').attr("placeholder", "How Can We Help You?");

// Fix for Chrome Form Autofill for our contact form
$(".contactForm input[name*=Name]").attr('autocomplete', 'name');
$(".contactForm input[name*=Email]").attr('autocomplete', 'email');
$(".contactForm input[name*=Phone]").attr('autocomplete', 'tel');
// Or you could turn it off
//$('form').attr('autocomplete', 'off');

//////////////////////////////////////////////////////////////////////////////////////////////////////////
// Misc
//////////////////////////////////////////////////////////////////////////////////////////////////////////

//// Expand Expertise section (Home Page)
//$(".btnExpandExpertise").on("click", function () {

//    $(".expertiseExpandable").slideToggle({
//        duration: 300,
//        easing: "swing"
//    });

//});

// Check if a link element has 
function isRelativeUrl(url) {
  var regex = new RegExp('^(?:[a-z]+:)?//', 'i');
  return regex.test(url);
}
function isExternal(url) {
  var match = url.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
  if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) return true;
  if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":(" + {
    "http:": 80,
    "https:": 443
  }[location.protocol] + ")?$"), "") !== location.host) return true;
  return false;
}

// Clickable items (e.g. a clickable article card with nested links)
$(document).on("click", ".clickable", function (event) {
  var $this = $(this);

  // If there's not data-url, then find the first child el with an href and use that
  var itemUrl = "";
  var target = "_self"; // default

  // First check for data atts. If none, use the first child link
  if (typeof $this.data("url") !== 'undefined' && $this.data("url").length) {
    itemUrl = $this.data("url");
    if (typeof $this.data("target") !== 'undefined' && $this.data("target").length) {
      target = $this.data("target");
    }
  } else {
    var $firstLinkFound = $this.find("a[href]").first();
    itemUrl = $firstLinkFound.attr("href");
    target = $firstLinkFound.attr("target") ? $firstLinkFound.attr("target") : target;
  }
  window.open(itemUrl, target);
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Resize Items based on the content inside them. Useful for sliders so that items remain same height
/// called like in window resize event: resizeItemsVertically($('.servicesList'), $('.servicesList .items .item .bottom'));
//////////////////////////////////////////////////////////////////////////////////////////////////////////
function resizeItemsVertically(baseElement, itemHeightElement) {
  if (baseElement.length > 0) {
    // check for element
    var itemsMaxHeight = 0;
    itemHeightElement.each(function () {
      var thisItemHeight = $(this).height();
      if (thisItemHeight > itemsMaxHeight) {
        itemsMaxHeight = thisItemHeight;
      }
    });
    itemHeightElement.height(itemsMaxHeight);
  }
}

// Clear Text Selection
function clearSelection() {
  if (document.selection) {
    document.selection.empty();
  } else if (window.getSelection) {
    window.getSelection().removeAllRanges();
  }
}

// Email link warning message
//window.addEventListener('DOMContentLoaded', function () {
//    $('a[href^="mailto"]').on("click", function () {
//        return confirm("Sending an e-mail to us will not make us your lawyers.  Please do not include any confidential information in your e-mail.");
//    });
//});

// Toggle accordianUL 
window.addEventListener('DOMContentLoaded', function () {
  var groupClass = "group";
  var expandedClass = "active";
  $(".accordionUL span.toggle").on("click", function () {
    toggleAccordion($(this).parent());
    return false;
  }).on("keypress", function (e) {
    if (e.which === 13) {
      // enter key code
      toggleAccordion($(this).parent());
      return false;
    }
  });

  // Toggle the target accordion
  function toggleAccordion($accordion) {
    if ($accordion.hasClass(expandedClass)) {
      collapseAccordion($accordion);
    } else {
      expandAccordion($accordion);
    }
  }
  function expandAccordion($accordion) {
    $(".accordionUL li." + expandedClass + ">ul").slideUp();
    $(".accordionUL li").removeClass(expandedClass);
    $accordion.addClass(expandedClass).children('ul').slideDown();
  }

  // Close single accordion (and update group)
  function collapseAccordion($accordion) {
    $(".accordionUL li").removeClass(expandedClass);
    $accordion.children('ul').slideUp();
  }
});

// Toggle Sections
window.addEventListener('DOMContentLoaded', function () {
  var expandedClass = "active";
  $(".toggleAction").on("click", function () {
    toggleContent($(this).next(".toggleContent"));
    return false;
  }).on("keypress", function (e) {
    if (e.which === 13) {
      // enter key code
      toggleContent($(this).next(".toggleContent"));
      return false;
    }
  });

  // Open the First
  $(".toggleAction").not(".startClosed").first().trigger('click');

  // Toggle the Content
  function toggleContent($toggleSection) {
    if ($toggleSection.parent().hasClass(expandedClass)) {
      collapseToggleContent($toggleSection);
    } else {
      //updateGroup($toggleSection);
      expandToggleContent($toggleSection);
    }
  }
  function updateGroup($toggleSection) {
    var groupName = $toggleSection.parent().attr("data-accordion-group");
    if (groupName) {
      $("[data-accordion-group='" + groupName + "']").each(function () {
        collapseToggleContent($(this).find(".toggleContent"));
      });
    }
  }
  function expandToggleContent($toggleSection) {
    $toggleSection.parent().addClass(expandedClass);
    $toggleSection.slideDown({
      step: window.updateStickySidebarDimensions,
      complete: window.updateStickySidebarDimensions
    });
  }

  // Close single accordion (and update group)
  function collapseToggleContent($toggleSection) {
    $toggleSection.parent().removeClass(expandedClass);
    $toggleSection.slideUp({
      step: window.updateStickySidebarDimensions,
      complete: window.updateStickySidebarDimensions
    });
  }
});

// Our team position filters
window.addEventListener('DOMContentLoaded', function () {
  var $filters = $('.positionTypeFilters [data-filter]'),
    $filterItems = $('.filterable [data-position]');
  $filters.on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    $filters.removeClass('active');
    $this.addClass('active');
    var $filterPosition = $this.attr('data-filter');
    if ($filterPosition === 'all') {
      $filterItems.removeClass('is-selected').fadeOut().promise().done(function () {
        $filterItems.addClass('is-selected').fadeIn();
      });
    } else {
      $filterItems.removeClass('is-selected').fadeOut().promise().done(function () {
        $filterItems.filter('[data-position = "' + $filterPosition + '"]').addClass('is-selected').fadeIn();
      });
    }
  });
});

// Read more content
var $readMoreButtons = $('.readMoreAction');
var $fullTextWrappers = $('.readMoreText');
var buttonText;
var fullTextWrapper;
$fullTextWrappers.attr('hidden', true);
$readMoreButtons.removeAttr('hidden');

// add listener for each button
$readMoreButtons.each(function () {
  $(this).on('click', function () {
    fullTextWrapper = $(this).parent().find('.readMoreText');
    buttonText = $(this).find('.buttonText');

    //console.log(fullTextWrapper);

    // change attributes and text if full text is shown/hidden
    if (!fullTextWrapper.attr('hidden')) {
      buttonText.text('Read more');
      fullTextWrapper.attr('hidden', true);
      $(this).attr('aria-expanded', false);
    } else {
      buttonText.text('Read less');
      fullTextWrapper.removeAttr('hidden');
      $(this).attr('aria-expanded', true);
    }
  });
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////
/// SCROLL NAVIGATION / PAGE PROGRESS DOTS
////////////////////////////////////////////////////////////////////////////////////////////////////////////
window.addEventListener('DOMContentLoaded', function () {
  var $scrollSections = $(".scrollSection");
  if ($scrollSections.length > 1 && !isSitefinityEditor()) {
    // only enable if one or more section detected and if not in edit mode
    var showToolTips = false; // enable/disable tooltips on hover

    // Create the nav element
    $("body").append("<div id='scrollNav'></div>");
    var $scrollNav = $("#scrollNav");

    // Add a class to the body (to aid in adding left-space to )
    $("body").addClass("scrollNav");

    // Get all sections with the scrollSection class
    $.each($scrollSections, function (index, scrollSection) {
      var $scrollSection = $(scrollSection);
      var sectionCount = index + 1;

      // Make sure section has an ID
      var scrollNavID = $scrollSection.attr("id");
      if (!scrollNavID) {
        scrollNavID = "scrollSection_" + sectionCount;
        $(this).attr("id", scrollNavID);
      }

      // Make sure section has a title - even if generic
      var scrollNavTitle = "Section " + sectionCount; // Default title

      if ($scrollSection.data("scroll-section-title")) {
        scrollNavTitle = $scrollSection.data("scroll-section-title"); // data attribute based title
      } else if ($scrollSection.data("placeholder-label")) {
        scrollNavTitle = "Scroll to " + $scrollSection.data("placeholder-label"); // Sitefinity Layout Column Placeholder
      }

      // Add the link to the scroll nav
      if (showToolTips) {
        $scrollNav.append("<a href='#" + scrollNavID + "' rel='m_PageScroll2id'><span class='tooltip' title='" + scrollNavTitle + "' class='noUnderline'>" + scrollNavTitle + "</span><span class='sr-only'>" + scrollNavTitle + "</span></a>");
      } else {
        $scrollNav.append("<a href='#" + scrollNavID + "' rel='m_PageScroll2id'  title='" + scrollNavTitle + "' class='noUnderline'><span class='sr-only'>" + scrollNavTitle + "</span></a>");
      }
    });

    // Initialize PageScroll2id
    // Documentation: http://manos.malihu.gr/page-scroll-to-id/comment-page-1/
    var linkSelector = "a[rel='m_PageScroll2id']";
    // To implement check 
    var sectionAbove = false;
    if (sectionAbove) {
      $(linkSelector).mPageScroll2id({
        offset: $("header").height(),
        // use header height as the scroll offset
        appendHash: false,
        highlightSelector: "#scrollNav a"
      });
    } else {
      $(linkSelector).mPageScroll2id({
        appendHash: false,
        highlightSelector: "#scrollNav a"
      });
    }
  }
});

/* #endregion */
/****************************************************************************************************/

/****************************************************************************************************/
/* #region Accordions */
/****************************************************************************************************/

var groupClass = "group";
var expandedClass = "active";
$(document).ready(function () {
  var $accordions = $(".accordion"); //.not(".disabled");
  if ($accordions.length && !isSitefinityEditor()) {
    // Add accessibility attributes
    updateAccordionAccessibilityAtts();

    // Add expand/collapse all button to first accordion
    //$accordions = $(".accordion");
    //if ($accordions.length > 1) {
    //    $("<div class='btnExpandAll expand'>Expand All</div>").prependTo($accordions.first());
    //    $accordions.first().addClass("hasExpandAll");
    //}
    // ToDo: Find a better way of adding the expand/collapse all button without making the <dl> markup invalid

    // Expand first 
    if ($(".accordion." + expandedClass).length) {
      expandAccordion($(".accordion." + expandedClass).first());
    }

    // Open all accordions with the "active" class
    $(".accordion.active").each(function () {
      var $accordion = $(this);
      expandAccordion($accordion);
    });

    // Click & Keypress handlers
    $(".accordion .accordionTop").on("click", function (ev) {
      //if ($(this).is(".disabled")) {
      //    return false;
      //}
      toggleAccordion($(this).parent(".accordion"));
      return false;
    }).on("keypress", function (ev) {
      if (ev.which === 13) {
        // enter key code
        //if ($(this).is(".disabled")) {
        //    return false;
        //}
        toggleAccordion($(this).parent(".accordion"));
        return false;
      }
    });

    // Expand / Collapse All accordions
    $(".btnExpandAll").on("click", function () {
      //debugger;
      var $button = $(this);
      if ($button.hasClass("expand")) {
        $accordions.each(function () {
          expandAccordion($(this)); // expand each accordion
        });
        updateExpandAllButton();
      } else {
        $accordions.each(function () {
          collapseAccordion($(this)); // close each accordion
        });
        updateExpandAllButton();
      }
    });
  }
});
function updateAccordionAccessibilityAtts() {
  // Make sure they're tab navigable/focusable
  $(".accordion").each(function (i, el) {
    var $accordion = $(el);
    var $accordionTop = $accordion.find(".accordionTop");
    var $accordionBottom = $accordion.find(".accordionBottom");
    if ($accordionTop.length && $accordionBottom.length) {
      // make sure accordionBottoms have unique Ids
      var accordionBottomId = $accordionBottom.uniqueId().attr("id"); // ToDo: get this

      // make accodions focusable
      $accordionTop.attr("tabindex", "0");
      var accordionTitle = $accordionTop.text().trim();
      if (!$accordionTop[0].hasAttribute("aria-label") && $accordionTop.attr("aria-label") !== "") {
        $accordionTop.attr("aria-label", accordionTitle);
        $accordionTop.attr("aria-controls", accordionBottomId);
        if ($accordionTop.is(".active")) {
          $accordionTop.attr("aria-expanded", "true");
          $accordionBottom.attr("aria-hidden", "false");
        } else {
          $accordionTop.attr("aria-expanded", "false");
          $accordionBottom.attr("aria-hidden", "true");
        }
      }
    }
  });
}

// Update the expand button to reflect current state of accordions
function updateExpandAllButton() {
  var $button = $(".btnExpandAll");
  var $accordions = $(".accordion");
  var $activeAccordions = $accordions.filter(".active");
  if ($button.length && $accordions.length > $activeAccordions.length) {
    // if some are open (but not all) then set to expand
    $button.addClass("expand");
    $button.text("Expand All");
  } else {
    $button.removeClass("expand");
    $button.text("Collapse All");
  }
}

// Toggle the target accordion
function toggleAccordion($accordion) {
  if ($accordion.hasClass(expandedClass)) {
    collapseAccordion($accordion);
  } else {
    closeGroupMembers($accordion); // close group members first
    expandAccordion($accordion);
  }
  updateExpandAllButton();
}

// Expand single accordion (and upate group)
function expandAccordion($accordion) {
  $accordion.addClass(expandedClass);
  $accordion.find(".accordionTop").addClass(expandedClass);
  $accordion.find(".accordionTop").attr("aria-expanded", "true");
  $accordion.find(".accordionBottom").addClass(expandedClass).slideDown();
  $accordion.find(".accordionBottom").attr("aria-hidden", "false");
  updateExpandAllButton();
}

// Close single accordion (and upate group)
function collapseAccordion($accordion) {
  $accordion.removeClass(expandedClass);
  $accordion.find(".accordionTop").removeClass(expandedClass);
  $accordion.find(".accordionTop").attr("aria-expanded", "false");
  $accordion.find(".accordionBottom").removeClass(expandedClass).slideUp();
  $accordion.find(".accordionBottom").attr("aria-hidden", "true");
  updateExpandAllButton();
}

// Check if accordion in group. If so, update group members
function closeGroupMembers($accordion) {
  var classes = $accordion[0].className.trim().split(/ |\t|\|/); // get array of classes (regex to account for space, tab, and pipe separators)
  var groups = $.grep(classes, function (classes, i) {
    // get only the classes containing groupClass
    return classes.indexOf(groupClass) === 0;
  });
  $.each(groups, function (i, group) {
    $(".accordion." + group).each(function () {
      collapseAccordion($(this)); // close each grouped accordion
    });
  });
}

/* #endregion */
/****************************************************************************************************/

/****************************************************************************************************/
/* #region Landing Page (Next Level 2024) */
/****************************************************************************************************/

$(document).ready(function () {
  if (!isSitefinityEditor() && $("body").hasClass("landingPage")) {
    // Set depth on svg elements based on the number of paths found
    //var numPaths = $bgTextureLines.length;
    //var depthIncrement = 1 / numPaths;

    //$bgTexture.find("#lines > g").each(function (index, el) {
    //    var depth = depthIncrement * index;
    //    $(el).attr("data-depth", depth);
    //});

    if ($("svg .clouds").length) {
      // init parallax
      var scene = document.querySelector('svg .clouds');
      var parallaxInstance = new Parallax(scene, {
        relativeInput: true,
        frictionX: 0.02,
        // effectively the easing of the parallax animation
        frictionY: 0.02
      });
    }

    // GSAP Scrolling Animation
    var timeline = gsap.timeline({
      paused: true,
      //scrollTrigger: ".bottomGroup",
      scrollTrigger: {
        trigger: ".trigger",
        //pin: true, // pin the trigger element while active
        //start: 0, // when the top of the trigger hits the top of the viewport
        end: 1500,
        // end after scrolling 500px beyond the start
        start: 0,
        scrub: 1 // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
        //snap: {
        //    snapTo: "labels", // snap to the closest label in the timeline
        //    duration: { min: 0.2, max: 3 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
        //    delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
        //    ease: "power1.inOut", // the ease of the snap animation ("power3" by default)
        //},
      }
    });

    // move the top blog down onto the second block
    timeline.from(".topGroup", {
      y: -5,
      x: 0,
      duration: 1
    }, 0);

    // move the bottom group up into place
    timeline.from(".bottomGroup", {
      y: 200,
      x: 100,
      duration: 1
    }, 0);

    // move the flag up the pole
    timeline.from(".flagWrapper", {
      y: 400,
      duration: 1
    }, ">"); // starts as soon as the blocks connect

    // hide the blocks behind the bottom clouds and fade out
    timeline.to(".blocksGroup", {
      y: 100,
      duration: 1,
      opacity: 0
    }, ">+1.5");

    //setTimeout(function () {
    //    timeline.play();
    //}, 1000);

    var rocketTimeline = gsap.timeline({
      paused: true,
      //scrollTrigger: ".bottomGroup",
      scrollTrigger: {
        //trigger: ".bottomContent",
        trigger: ".bottomContent",
        //pin: true, // pin the trigger element while active
        //start: "top bottom", // when the top of the trigger hits the top of the viewport
        end: 400,
        // end after scrolling 500px beyond the start
        //start: 0,
        scrub: 1 // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
        //snap: {
        //    snapTo: "labels", // snap to the closest label in the timeline
        //    duration: { min: 0.2, max: 3 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
        //    delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
        //    ease: "power1.inOut", // the ease of the snap animation ("power3" by default)
        //},
      }
    });

    //rocketTimeline.to(".blocksGroup", { y: 100, duration: 1, opacity: 0 }, 0);
    rocketTimeline.from(".rocket", {
      rotation: -90,
      duration: 1
    }, 0);
  }
});

/* #endregion */
/****************************************************************************************************/

$(document).on("click", ".mobileHeader a", function () {
  //alert("clicked");
  $('#mobileHeader').popup("hide");
});